import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { actionModalCloseAll, actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { TypeActionShowMe } from "../../actionShowMe";
export var epicShowMeFulfillContract = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionShowMe.QuestTaskFulfillContract), switchMap(function (action) {
        return from([actionModalCloseAll(), actionModalOpen(IdModal.Market)]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/fulfill-contract/epicShowMeFulfillContract.ts
// module id = 2365
// module chunks = 3